export default {
    "ins_1": "Муштарии мӯҳтарам, барои гирифтани  пул ба корт дастурҳои зеринро иҷро кунед:",
    "ins_1_1": "Ҳисоби шахсии худ ва Санаи таваллудро ворид кунед",
    "ins_2": "Ҳисоби шахсии худро шумо метавонед аз ҳуҷҷати «Способы погашения микрозаймов через Партнеров» ё аз Мутахасиси худ дар М Булак фаҳмида гиред",
    "ins_3": "Агар маълумоти воридкардаи шумо дуруст бошад,\" тугмаи «Далее» \"- ро пахш кунед",
    "warn": "ДИҚҚАТ!",
    "warn_1": "Агар  дар паёмак номҳои пурраи шумо нишон дода нашуда бошанд, бо Мутахассиси худ дар M Булак тамос гиред.",
    "warn_2": "Агар шумо ин паёмакро ба таври хато кушодед, онро сарфи назар карда ягон маълумот дохил накунед.",
    "warn_3": "Агар шумо дастурҳоро бодиққат риоя карда, ҳама чизро дуруст ворид кардед, аммо ба рақами телефони худ Кодро нагирифтед,  ба Мутахассиси худ дар М Булак муроҷиат кунед.",
    "warn_4": "Агар шумо ҳама чизро дуруст иҷро кардед ва дастурҳоро то ба охир риоя кардед,  барои тасдиқи дурустии маълумоти воридкардаатон аз корти нишондодашудаатон 1 рубл гирифта мешавад. Дар давоми 10 дақиқа пас аз тасдиқи амалиёт, 1 рубл ба корти шумо баргардонида мешавад.",
    "birthday": "Санаи таваллудро ворид кунед",
    "account": "Ҳисоби шахсӣ",
    "digit_range": "Аз 2 то 5 рақам",
    "next": "Баъдан",
    "field_required": "Ин майдонро пур кунед",
    "operation_failure": "Амалиёт бе муваффақият анҷом шуд",
    "processing": "Раванд идома дорад ",
    "continue": "Давом додан ",
    "enter_code": "Кодро дохил кунед",
    "page_not_found": "Саҳифа ёфт нашуд",
    "my_docs": "Мои документы Ҳуҷҷатҳои ман ",
    "close": "Пӯшидан",
    "credit_card": {
        "card_number": "Номер карты Рақами корт ",
        "card_expiration_date": "Мӯҳлати эътибор ",
        "check": "Санҷидан",
        "submit": "Тасдиқ кардан"
    },
    "repay": {
        "h3": "Диққат! ",
        "h4_title": "Диққат:",
        "h4_subtitle": "Пардохт фавран ба ҳисоб гирифта намешавад, пешакӣ пардохт мекунед: 2-3 рӯз пеш аз санаи ҷадвал.",
        "h4_subtitle_2": "М Булак барои пардохт комиссия намегирад.  Ҳама гуна комиссия комиссияи бонки шумост.",
        "h4_subtitle_3": "Инчунин хотиррасон мекунем, ки пардохт фавран гирифта намешавад ва коркарди он аз тарафи Бонк метавонад  чанд рӯз давом кунад",
        "h4_subtitle_4": "Барои пешгирӣ кардани дермонии пардохтҳо пешакӣ пардохт кунед.",
        "birthday": "Санаи таваллуд",
        "account": "Ҳисоби шахсӣ ",
        "amount": "Маблағи пардохт ",
        "to_main_site": "Ба саҳифаи асосӣ ",
        "check": "Санҷиш",
        "loans": "Қарзҳо ",
        "payment": "Пардохт",
        "forgot": "Фаромӯш кардед?",
        "title": "Пардохти онлайнии қарз ",
        "modal": {
            "header": "Ҳисоби шахсии худро чи тавр фаҳмидан мумкин?",
            "p1": "Агар шумо ҳисоби шахсии худро фаромӯш кардед, аз телефоне, ки дар Ширкат ба қайд гирифта шудааст СМС *-паёмакро бо калимаи «info» ба рақами  8(903) 76-76-000 фиристонед, ба шумо СМС паёмак бо рақами ҳисоби шахсии шумо хоҳад омад",
            "p2": "Инчунин, ҳангоми додани қарз ё пардохт ба рақами телефони шумо, ки дар Ширкат ба қайд гирифта шудааст паёмак бо рақами ҳисоби шахсии дар он нишон дода шуда «L/chet:XX», равон карда мешавад.",
            "p3": "*Арзиши як СМС-паёмак тибқи нақшаи тарофавии операторатон муайян карда мешавад."
        }
    },
    "user_docs": {
        "attach": "Замима кунед",
        "processing": "Ҳуҷҷат коркард шуда истодааст",
        "page": "Саҳифаи {0} аз {1} ",
        "warning": "ДИҚҚАТ! Пеш аз замима кардани ҳуҷҷатҳо, тафтиш кардан зарур аст, ки ҳамаи аксҳои ҳуҷҷатҳо хуб намоён, бидуни ҷило додан ва сиёҳӣ бошанд! Дар сурати мувофиқат накардани нусхаҳои ҳуҷҷатҳо ба талаботи сифат - онҳо қабул карда намешаванд."
    },
    "error_unexpected": "Хатогии ногаҳонӣ рух дод",
    "doc_view": {
        "null": "Маълумот ба имрӯз мувофиқ нест"
    },
    "choose_loan": "Шартномаеро интихоб кунед, ки бо он пардохт кардан мехоҳед",
    "wrong_amount": "Маблағи на зиёдтар аз 150 000 рублро гузоред"
};

export const validation = {
    required: "Ин майдони ҳатмӣ аст",
    numeric: "Арзиши майдон бояд ададӣ бошад",
    positive: "Арзиши майдон бояд мусбат бошад",
    alpha: "Арзиши майдон бояд ҳарфакӣ бошад",
    invalid_email: "Шакли нодурусти суроғаи почтаи электронӣ",
    card_number: "Рақами нодурусти корт",
    invalid_date: "Санаи нодуруст",
    card_expired: "Мӯҳлати корт гузаштааст",
    file_size: "Ҳаҷми файл {0} аз меъёри иҷозатшуда зиёдтар аст, {1}мб",
    file_type: "Навъи файли нодурусти {0}, яке аз инҳоро интихоб кунед: {1}",
    client_account: "Ҳисоби шахсӣ бояд аз 2 то 5 рақам дошта бошад",
    repay_amount: "Маблағи пардохт бояд аз 36 то 1000000 рубл бошад",
    char_length: "Дарозии майдон бояд {0} бошад",
    char_length_within: "Дарозии майдон бояд камтар аз {0} ва зиёда аз {1} бошад",
};
